import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize Sentry for error tracking (only if configured)
const SENTRY_DSN = process.env['REACT_APP_SENTRY_DSN'];

if (SENTRY_DSN) {
  // Dynamic import of Sentry to avoid loading when not needed
  // @ts-ignore - @sentry/react is optional dependency
  import('@sentry/react').then((Sentry: { init: (config: Record<string, unknown>) => void }) => {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: process.env['REACT_APP_ENVIRONMENT'] || 'development',
      release: process.env['REACT_APP_VERSION'] || '1.0.0',
      // Performance monitoring
      tracesSampleRate: parseFloat(process.env['REACT_APP_SENTRY_TRACES_SAMPLE_RATE'] || '0.1'),
      // Session replay (optional)
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      // Don't send PII
      beforeSend(event: Record<string, unknown>) {
        // Scrub sensitive data if needed
        return event;
      },
      // Ignore common non-actionable errors
      ignoreErrors: [
        // Browser extensions
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
        // Network errors (handled elsewhere)
        'Network Error',
        'Failed to fetch',
        // User-initiated navigation
        'cancelled',
      ],
    });
  }).catch(() => {
    // Sentry failed to load - that's okay
    console.warn('Sentry initialization failed - error tracking disabled');
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
